import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GridViewCellComponent } from './grid-view-cell.component';

@NgModule({
  declarations: [GridViewCellComponent],
  imports: [CommonModule],
  exports: [GridViewCellComponent],
})
export class GridViewCellModule {}
